<template>
  <nx-live-football-match-players
    v-validate="validation"
    data-vv-value-path="value"
    v-bind="$attrs"
    :data-vv-scope="scope"
    :data-vv-name="name"
    :data-vv-as="label"
    :ref="name"
    :label="label"
    :required="required"
    :disabled="disabled"
    :error-messages="errorMessages"
    :players="value"
    v-on="$listeners"
    @input="onInput"
  ></nx-live-football-match-players>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxLiveFootballMatchPlayers from '@/modules/live/LiveFootballMatchPlayers';

export default {
  name: 'nx-live-football-match-players-form',
  components: { NxLiveFootballMatchPlayers },
  mixins: [FormElement],
  data() {
    return {
      currentValue: this.value,
    };
  },
  props: {
    value: {
      type: Array,
    },
  },
  methods: {
    async onInput(value) {
      this.$parentForm.updateField(this.name, value);
      this.$emit('input', value);
    },
  },
  computed: {},
};
</script>
